import React, { Component } from 'react';
import Loader from "../../utils/Loader";
import Footer from "../../common_components/Footer";
import Header from "../../common_components/Header";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";
import { BASE_URL, toastError } from "../../utils/constants";
import { Modal } from "react-bootstrap";
import { getCmsContent_action } from "../../actions/cms_action/cmsAction";
class index extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            currentIndex: 0,
            cmsSectionData: [],
            MenuID: '', MenuUrl: '',
            cmsMenuData: [], cmsFooterData: [], cmsBannerData: [], isBannerOpen: false,
            cmsSubheaderData: [], downloadUrl: '',
            isHomePage: false
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
        const sortUrl = BASE_URL.split("/api");
        this.setState({ downloadUrl: sortUrl[0] });
        if (this.props.location.pathname === '/') {
            this.setState({ MenuUrl: 'home', MenuID: 1, cmsMenuData: [], isHomePage: true }, () => {
                this.getCmsContent(1, 'home');
                setTimeout(() => {
                    this.runDynamicScripts()
                }, 500);
            });
            return
        }
        const urlHash = this.props.location.pathname;
        if (urlHash) {
            const parts = urlHash.split('&');
            if (parts.length === 2) {
                const MenuUrl = parts[0];
                const MenuID = parts[1];
                this.setState({ MenuUrl: MenuUrl || 'home', MenuID: MenuID || 1, cmsMenuData: [] }, () => {
                    this.getCmsContent(MenuID || 1, MenuUrl || 'home');
                    setTimeout(() => {
                        this.runDynamicScripts()
                    }, 1000);
                });
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            window.scrollTo(0, 0); // Scroll to top on route change
            const urlHash = this.props.location.pathname;
            if (urlHash === '/') {
                this.setState({ MenuUrl: 'home', MenuID: 1, cmsMenuData: [], isHomePage: true }, () => {
                    this.getCmsContent(1, 'home')
                    setTimeout(() => {
                        this.runDynamicScripts()
                    }, 1000);
                })
            } else if (urlHash) {
                const parts = urlHash.split('&');
                if (parts.length === 2) {
                    const MenuUrl = parts[0];
                    const MenuID = parts[1];
                    if (MenuID === '1' && !this.state.isHomePage) {
                        window.location.href = '/'; // Use href for a full reload to home
                        return;
                    }
                    this.setState({ MenuUrl, MenuID, cmsMenuData: [], isHomePage: false }, () => {
                        this.getCmsContent(MenuID, MenuUrl);
                        setTimeout(() => {
                            this.runDynamicScripts()
                        }, 1000);
                    });
                }
            }
        }
    }

    async getCmsContent(MenuID, MenuUrl) {
        const { isHomePage } = this.state;
        const formattedMenuUrl = MenuUrl?.startsWith('/') ? MenuUrl.substring(1) : MenuUrl;
        try {
            this.setState({ isLoading: true });
            const data = await this.props.getCmsContent_action(MenuID || 1, formattedMenuUrl || 'home');
            if (data.error !== 1) {
                this.setState({
                    isLoading: false,
                    cmsSectionData: data?.data[0] !== "" ? data?.data[0] : [],
                    cmsMenuData: data?.data[1] !== "" ? data?.data[1] : [],
                    cmsFooterData: data?.data[2][0] !== "" ? data?.data[2][0] : [],
                    cmsUploadData: data?.data[3] !== "" ? data?.data[3] : [],
                    cmsSubheaderData: data?.data[4] !== "" ? data?.data[4] : [],
                    cmsBannerData: data?.data[5][0] !== "" ? data?.data[5][0] : [],
                    isBannerOpen: data?.data?.[5]?.[0]?.isActive === true ? (isHomePage === true && true) : false
                });
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
                if (data.msg === 'Page not found.') {
                    this.props.navigate('/');
                }
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }

    checkDateAndHandleAction = () => {
        const currentDate = new Date();
        const targetDate = new Date('2025-10-30T00:00:00');

        if (currentDate >= targetDate) {
            window.open('https://india-itme.com/#/visitorregistration/ITME2026', '_blank');
        } else {
            const modal = document.getElementById("timer_Modal2");
            if (modal) modal.classList.add("active");
        }
    }

    runDynamicScripts() {
        const slideToggle = (element, duration = 300) => {
            if (window.getComputedStyle(element).display === 'none') {
                element.style.display = 'block';
                const height = element.scrollHeight;
                element.style.overflow = 'hidden';
                element.style.maxHeight = 0;
                element.style.transition = `max-height ${duration}ms ease-in-out`;
                setTimeout(() => { element.style.maxHeight = height + 'px'; }, 10);
                setTimeout(() => {
                    element.style.removeProperty('max-height');
                    element.style.removeProperty('overflow');
                    element.style.removeProperty('transition');
                }, duration);
            } else {
                element.style.overflow = 'hidden';
                element.style.maxHeight = element.scrollHeight + 'px';
                element.style.transition = `max-height ${duration}ms ease-in-out`;
                setTimeout(() => { element.style.maxHeight = 0; }, 10);
                setTimeout(() => {
                    element.style.display = 'none';
                    element.style.removeProperty('max-height');
                    element.style.removeProperty('overflow');
                    element.style.removeProperty('transition');
                }, duration);
            }
        };

        const preloader = document.getElementById('preloader');
        if (preloader) {
            preloader.style.transition = 'opacity 0.5s ease';
            preloader.style.opacity = '0';
            setTimeout(() => preloader.style.display = 'none', 500);
        }

        if (typeof window.WOW === 'function') new window.WOW().init();
        if (typeof window.AOS === 'object' && window.AOS.init) {
            window.AOS.init({ duration: 1000, mirror: true, once: true, disable: 'mobile' });
        }

        const mobileMenuContainer = document.querySelector('.tgmobile__menu');
        if (mobileMenuContainer) {
            document.querySelectorAll('.tgmenu__wrap .navigation li.menu-item-has-children').forEach(item => {
                if (!item.querySelector('.dropdown-btn')) {
                    item.insertAdjacentHTML('beforeend', '<div class="dropdown-btn"><span class="plus-line"></span></div>');
                }
            });

            const mobileMenuOuter = document.querySelector('.tgmobile__menu-box .tgmobile__menu-outer');
            if (mobileMenuOuter && !mobileMenuOuter.innerHTML) {
                const mainMenuContent = document.querySelector('.tgmenu__wrap .tgmenu__main-menu')?.innerHTML;
                if (mainMenuContent) mobileMenuOuter.innerHTML = mainMenuContent;
            }

            document.querySelectorAll('.tgmobile__menu li.menu-item-has-children .dropdown-btn').forEach(button => {
                button.addEventListener('click', function () {
                    this.classList.toggle('open');
                    const submenu = this.previousElementSibling;
                    if (submenu && submenu.tagName === 'UL') slideToggle(submenu, 300);
                });
            });

            document.querySelector('.mobile-nav-toggler')?.addEventListener('click', () =>
                document.body.classList.add('mobile-menu-visible')
            );
            document.querySelectorAll('.tgmobile__menu-backdrop, .tgmobile__menu .close-btn').forEach(closer => {
                closer.addEventListener('click', () => document.body.classList.remove('mobile-menu-visible'));
            });
        }

        window.addEventListener('scroll', () => {
            const scroll = window.scrollY;
            const stickyHeader = document.getElementById('sticky-header');
            const scrollToTarget = document.querySelector('.scroll-to-target');
            const headerFixedHeight = document.getElementById('header-fixed-height');

            if (scroll < 245) {
                stickyHeader?.classList.remove("sticky-menu");
                scrollToTarget?.classList.remove('open');
                headerFixedHeight?.classList.remove("active-height");
            } else {
                stickyHeader?.classList.add("sticky-menu");
                scrollToTarget?.classList.add('open');
                headerFixedHeight?.classList.add("active-height");
            }
        });

        const scrollToTargetBtn = document.querySelector('.scroll-to-target');
        if (scrollToTargetBtn) {
            scrollToTargetBtn.addEventListener('click', function () {
                const target = document.querySelector(this.getAttribute('data-target'));
                if (target) window.scrollTo({ top: target.offsetTop, behavior: 'smooth' });
            });
        }

        document.querySelectorAll("[data-background]").forEach(el =>
            el.style.backgroundImage = `url(${el.getAttribute("data-background")})`
        );
        document.querySelectorAll("[data-bg-color]").forEach(el =>
            el.style.backgroundColor = el.getAttribute("data-bg-color")
        );

        document.querySelector(".search-open-btn")?.addEventListener("click", () => {
            document.querySelector(".search__popup")?.classList.add("search-opened");
            document.querySelector(".search-popup-overlay")?.classList.add("search-popup-overlay-open");
        });
        document.querySelector(".search-close-btn")?.addEventListener("click", () => {
            document.querySelector(".search__popup")?.classList.remove("search-opened");
            document.querySelector(".search-popup-overlay")?.classList.remove("search-popup-overlay-open");
        });

        document.querySelector(".menu-tigger")?.addEventListener("click", (e) => {
            e.preventDefault();
            document.querySelector(".offCanvas__info")?.classList.add("active");
            document.querySelector(".offCanvas__overly")?.classList.add("active");
        });

        document.querySelectorAll(".menu-close, .offCanvas__overly").forEach(el => {
            el.addEventListener("click", () => {
                document.querySelector(".offCanvas__info")?.classList.remove("active");
                document.querySelector(".offCanvas__overly")?.classList.remove("active");
                document.querySelector(".offCanvas__info1")?.classList.remove("active");
            });
        });

        // ----------------- ✅ Inject PDF Modal (Only Once) -----------------
        if (!document.getElementById("pdfProtectedModal")) {
            const modal = document.createElement("div");
            modal.id = "pdfProtectedModal";
            modal.style.cssText = `
            display:none; position:fixed; z-index:99999; top:0; left:0; width:100%; height:100%;
            background:rgba(0,0,0,0.7);
        `;
            modal.innerHTML = `
            <iframe id="pdfProtectedViewer" style="width:80%;height:90%;margin:40px auto;display:block;border:none;"></iframe>
            <button id="pdfProtectedClose"
                style="position:absolute;top:20px;right:30px;font-size:22px;padding:6px 15px;background:#fff;border:none;border-radius:4px;cursor:pointer;">
                ✖ Close
            </button>
        `;
            document.body.appendChild(modal);

            // Block selection & copy on modal content
            const cssBlock = document.createElement("style");
            cssBlock.innerHTML = `
            #pdfProtectedModal, #pdfProtectedModal * {
                user-select: none !important;
                -webkit-user-select: none !important;
            }
        `;
            document.head.appendChild(cssBlock);
        }

        // ----------------- ✅ Secure PDF Viewer -----------------
        setTimeout(() => {
            const pdfLinks = document.querySelectorAll('a[href$=".pdf"], a[href*=".pdf"]');

            pdfLinks.forEach(link => {
                link.addEventListener("click", function (e) {
                    e.preventDefault();
                    const pdfUrl = this.getAttribute("href");
                    if (!pdfUrl) return;

                    const viewer = document.getElementById("pdfProtectedViewer");
                    viewer.src = pdfUrl.split("#")[0] + "#toolbar=0&navpanes=0&scrollbar=0";

                    document.getElementById("pdfProtectedModal").style.display = "block";
                    document.body.style.overflow = "hidden"; // ✅ Stop background scroll
                });
            });

            document.getElementById("pdfProtectedClose").addEventListener("click", () => {
                document.getElementById("pdfProtectedModal").style.display = "none";
                document.getElementById("pdfProtectedViewer").src = "";
                document.body.style.overflow = ""; // ✅ Restore background scroll
            });

            document.addEventListener("contextmenu", e => {
                if (document.getElementById("pdfProtectedModal").style.display === "block") e.preventDefault();
            });

            document.addEventListener("keydown", e => {
                if (document.getElementById("pdfProtectedModal").style.display === "block" &&
                    (e.ctrlKey && (e.key === "c" || e.key === "p" || e.key === "s" || e.key === "x"))) {
                    e.preventDefault();
                }
            });

        }, 700);
    }

    render() {
        const { isLoading, cmsSectionData, cmsMenuData, cmsFooterData, cmsBannerData, downloadUrl } = this.state;
        return (
            <>
                {isLoading && <Loader />}
                <main className="main-area fix">
                    <Header headerNavs={cmsMenuData} />

                    {cmsSectionData?.length > 0 && cmsSectionData
                        .filter(section => section.isPublish && section.isactive)
                        .sort((a, b) => a.SeqNo - b.SeqNo)
                        .map((section, index) => (
                            <section key={section.ContentID || index} className="p-0">
                                <div dangerouslySetInnerHTML={{ __html: section.SectionContent }} />
                            </section>
                        ))}

                    {cmsBannerData?.isActive && cmsBannerData.isPublish && (
                        <Modal
                            show={this.state.isBannerOpen}
                            onHide={() => this.setState({ isBannerOpen: false })}
                            centered
                        >
                            <Modal.Body className="p-0 position-relative">
                                <button
                                    type="button"
                                    className="btn-close position-absolute top-0 end-0 m-2 bg-light"
                                    aria-label="Close"
                                    onClick={() => this.setState({ isBannerOpen: false })}
                                ></button>
                                <img width='100%' height='auto'
                                    src={`${downloadUrl + cmsBannerData?.BannerFilepath}`}
                                    alt="banner"
                                />
                            </Modal.Body>
                        </Modal>
                    )}

                    <div className="modal timerPop" id="timer_Modal1">
                        <div className="modal-dialog timer_modal_dialog timer_modal_width">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <button type="button" className="btn-close" id="close_timer_Modal1"></button>
                                    <section className="container text-center">
                                        <img src="assets/img/logo_2.png" alt="logo" className="image" />
                                        <header className='mt-3'>Coming Soon</header>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal timerPop" id="timer_Modal2">
                        <div className="modal-dialog timer_modal_dialog timer_modal_width">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <button type="button" className="btn-close" id="close_timer_Modal2"></button>
                                    <section className="container text-center">
                                        <img src="assets/img/logo_2.png" alt="logo" className="image" />
                                        <header className='mt-3'>Coming Soon</header>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>

                </main>

                <Footer footerData={cmsFooterData} />
            </>
        )
    }
}

export default withRouter(connect(null, { getCmsContent_action })(index));